import React, { useRef, useEffect, useState } from "react";
import "./ExperienceCard.css";
import { Fade } from "react-reveal";
import { useTranslation } from "react-i18next";

const ExperienceCard = ({
  experience,
  experienceKey,
  sectionType,
  index,
  totalCards,
  theme,
}) => {
  const { t } = useTranslation();
  const cardRef = useRef(null);
  const [connectorHeight, setConnectorHeight] = useState(200); // Default fallback

  useEffect(() => {
    const calculateConnectorHeight = () => {
      if (cardRef.current && index !== totalCards - 1) {
        const cardElement = cardRef.current;
        const cardHeight = cardElement.offsetHeight;
        const marginTop = index === 0 ? 30 : 50;

        // Calculate dynamic height: card height + margin + buffer to reach next stepper
        const dynamicHeight = cardHeight + marginTop + 60; // 60px buffer for stepper positioning
        setConnectorHeight(dynamicHeight);
      }
    };

    // Calculate on mount and when content changes
    calculateConnectorHeight();

    // Recalculate on window resize for responsive behavior
    window.addEventListener("resize", calculateConnectorHeight);

    return () => {
      window.removeEventListener("resize", calculateConnectorHeight);
    };
  }, [experience.description, index, totalCards]); // Recalculate when description changes

  return (
    <div
      className="experience-list-item"
      style={{ marginTop: index === 0 ? 30 : 50 }}
      ref={cardRef}
    >
      <Fade left duration={2000} distance="40px">
        <div
          className="experience-card-logo-div"
          style={{ backgroundColor: experience.color || "#fff" }}
        >
          <img
            className="experience-card-logo"
            src={require(`../../assets/images/${experience.logo_path}`)}
            alt=""
          />
        </div>
      </Fade>
      <div className="experience-card-stepper">
        <div
          style={{
            width: 20,
            height: 20,
            backgroundColor: "#bdbdbd",
            borderRadius: 50,
            zIndex: 100,
          }}
        />
        {index !== totalCards - 1 && (
          <div
            className="timeline-connector"
            style={{
              width: 2,
              backgroundColor: "#bdbdbd",
              position: "absolute",
              top: 10,
              height: connectorHeight,
              left: 9,
            }}
          />
        )}
      </div>
      <Fade right duration={2000} distance="40px">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            width: "100%",
          }}
        >
          <div
            className="arrow-left"
            style={{ borderRight: `10px solid ${theme.body}` }}
          ></div>
          <div
            className="experience-card"
            style={{ background: `${theme.body}` }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h3
                  className="experience-card-title"
                  style={{ color: theme.text }}
                >
                  {t(
                    `portfolio.experience.${sectionType}.${experienceKey}.title`
                  )}
                </h3>
                <p
                  className="experience-card-company"
                  style={{ color: theme.text }}
                >
                  <a
                    href={experience.company_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t(
                      `portfolio.experience.${sectionType}.${experienceKey}.company`
                    )}
                  </a>
                </p>
              </div>
              <div>
                <div className="experience-card-heading-right">
                  <p
                    className="experience-card-duration"
                    style={{ color: theme.secondaryText }}
                  >
                    {t(
                      `portfolio.experience.${sectionType}.${experienceKey}.duration`
                    )}
                  </p>
                  <p
                    className="experience-card-location"
                    style={{ color: theme.secondaryText }}
                  >
                    {t(
                      `portfolio.experience.${sectionType}.${experienceKey}.location`
                    )}
                  </p>
                </div>
              </div>
            </div>
            <div
              className="experience-card-description"
              style={{ color: theme.text, marginTop: 20 }}
            >
              <ul
                style={{
                  margin: 0,
                  width: "100%",
                  maxWidth: "100%",
                  boxSizing: "border-box",
                }}
              >
                {t(
                  `portfolio.experience.${sectionType}.${experienceKey}.descriptions`,
                  { returnObjects: true }
                ).map((point, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: point }} />
                ))}
              </ul>
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default ExperienceCard;
